export default "__VITE_ASSET__5vuCPYef__"